export enum IncompleteReasonType {
    L1Form = 0,
    LandPurchaseContract = 1,
    SurveyOrPlatMap = 2,
    Plans = 3,
    SpecSheet = 4,
    LastTwoMonthBankStatements = 5,
    Insurance = 6,
    Permit = 7,
    CompanyFinancialStatements = 8,
    PersonalFinancialStatements = 9,
    CompanyTaxReturn = 10,
    PersonalTaxReturn = 11,
    TermSheet = 12,
    L1RForm = 13,
    Survey = 14,
    Leases = 15,
    PropertyManagementContract = 16,
    MostRecentRealEstateTaxBill = 17,
    HoweOwnersCondiminiumAssociationBill = 18,
    FinancialStatement = 19,
    ByLawsOfAssociation = 20,
    CurrentOrQuotedInsurancePolicies = 21,
    RecentInteriorOrExperiorPhotos = 22,
    S1Form = 23,
    DriversLicenseImage = 24,
    C1RForm = 25,
    Resume = 26,
    OrganizationalDocuments = 27,
    C1Form = 28,
    BuildingPermits = 29,
    BorrowerInformationForm = 30,
    AgreementOfCompliance = 31,
    ManagementResume = 32,
    MarketInformation = 33,
    WorkInProcess = 34,
    BusinessDebtSchedule = 35,
    ProjectedBusinessCashFlows = 36,
    MonthlyCashFlowProjections = 37,
    DetaileddescriptionOfProjects = 38,
    LetterFromLocalMortgageLender = 39,
    LetterFromLocalRealEstateBroker = 40,
    CertificateOfOccupancyOrEquivalent = 41,
    VerificationOfMortgage = 42,
    InitialTermOrOtherOptionNotChosen = 43,
}
